export const DEFAULT_VALUE = "-";
export const DEFAULT_PAGE_START = 1;
export const ROWS_PER_PAGE = 10;
export const ROWS_PER_PAGES = [ROWS_PER_PAGE, 25, 50, 100];
